import React from 'react'
import PropTypes from 'prop-types'
import { AppBar, Button, IconButton, Stack, Toolbar, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { IS_NEW_LAYOUT_ENABLED, NEW_CONTAINER_WIDTH, MAX_CONTAINER_WIDTH } from 'constants/layoutConstant'
import { MESSAGES } from '../../messages/messages'

const Header = ({ rightSideIcons, showRightSideIcons, handleBack }) => {
    let listKey = Date.now()
    return (
        <AppBar
            component="header"
            position="sticky"
            sx={{
                backgroundColor: 'background.default',
                borderBottom: IS_NEW_LAYOUT_ENABLED ? 'none' : (theme) => `1px solid ${theme.palette.common.gray.main}`,
                boxShadow: IS_NEW_LAYOUT_ENABLED ? 'none' : '0px 5px 10px rgba(0, 0, 0, 0.05)',
                borderRadius: 0,
                color: 'text.primary',
                height: { xs: 56, md: 80 },
                justifyContent: 'space-between',
                alignItems: 'unset',
                py: {
                    xs: 4,
                    md: '24px 72px'
                },
                pl: 0,
                pr: {
                    xs: 4,
                    md: 0
                },
                zIndex: 3,
                top: '55px'
            }}
            data-testid="header"
        >
            <Toolbar
                disableGutters
                sx={{
                    justifyContent: 'space-between',
                    minHeight: { xs: 24 },
                    maxWidth: IS_NEW_LAYOUT_ENABLED ? NEW_CONTAINER_WIDTH : MAX_CONTAINER_WIDTH,
                    px: IS_NEW_LAYOUT_ENABLED ? { xs: 1, md: 14, lg: 14 } : { xs: 1 },
                    m: 'auto',
                    width: '-webkit-fill-available'
                }}
            >
                <Button
                    variant="text"
                    disableRipple
                    data-testid="back"
                    onClick={handleBack}
                    sx={{
                        color: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 3,
                        pl: { xs: 3, md: 0 }
                    }}
                >
                    <FontAwesomeIcon icon={faAngleLeft} size="xl" />
                    <Typography
                        component="span"
                        sx={{
                            typography: 'boldBody2',
                            mt: 0.6
                        }}
                    >
                        {MESSAGES.back_to_dashboard}
                    </Typography>
                </Button>
                {showRightSideIcons && !IS_NEW_LAYOUT_ENABLED && (
                    <Stack
                        direction="row"
                        sx={{
                            p: 2.5,
                            px: 0,
                            gap: 2.5
                        }}
                    >
                        {rightSideIcons.map(({ icon, alt, handler }, index) => (
                            <IconButton
                                aria-label={alt}
                                padding={1}
                                key={`${index + listKey}`}
                                onClick={handler}
                                data-testid={alt}
                                sx={{
                                    border: '1px solid rgba(0, 9, 91, 0.25)'
                                }}
                            >
                                <img src={icon} alt={alt} width={24} height={24} />
                            </IconButton>
                        ))}
                    </Stack>
                )}
            </Toolbar>
        </AppBar>
    )
}

Header.propTypes = {
    rightSideIcons: PropTypes.array,
    showRightSideIcons: PropTypes.bool,
    handleBack: PropTypes.func
}

export default Header
